import React, { useState } from 'react';
import './Highspeedhybrid.css';
import Highspeed1 from '../../../imgs/Highspeed1.webp';
import Highspeed2 from '../../../imgs/Highspeed2.webp';
import Highspeed3 from '../../../imgs/Highspeed3.webp';
import Highspeed4 from '../../../imgs/Highspeed4.webp';
import Reqprodcte from "../../../components/Reqprodcte"; 


const images = [
    { src: Highspeed1 },
    { src: Highspeed2 },
    { src: Highspeed3 },
    { src: Highspeed4 },
];

const Highspeedhybrid = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Highspeed-main-container">
            {/* Left: Slideshow */}
            <div className="Highspeed-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            {/* Right: Text Section */}
            <div className="Highspeed-text">
                <h2>High Speed Hybrid Injection Molding Machinee</h2>
                <h3>JEV SERIESV</h3>
                <p>
                    Disha JEV Series Hybrid Injection Molding Machine combine electric’s high speed, precision and hydraulic’s power for outstanding plastic production performance.
                </p>
                <ul>
                    <li><strong>Clamping Force:</strong> 300~380(KN)</li>
                    <li><strong>Driving System:</strong> Hybrid</li>
                    <li><strong>Motor Type:</strong> Servo</li>
                    <li><strong>Shooting Weight(PS)-</strong> 511(g)</li>
                </ul>
 <div className='stnd'>
                            <Reqprodcte />
                        </div>            </div>
        </div>
    );
};

export default Highspeedhybrid;
